export default {
    "CHN": "Please enter your address in Chinese. </br>请用中文输入你的地址.",
    "BGR": "Enter your <b>home address</b> in English to receive your items.",
    "PRI": "Please enter your home address not a PO box to receive packages.",
    "SGP": "Please include your unit # in your address.",
    "SVK": "Please enter your address in <b>English</b>",
    "POL": "Please enter your address in <b>English</b>"
}